import React, { useEffect, useState } from 'react';
import useFordRidesContext from '../hooks/use-ford-rides-context';
import { useFordExportRidesContent } from '../hooks/use-ford-export-rides-content';
import { ActivityIndicator } from '../../../common/activity-indicator/activity-indicator';
import './rides-export.scss';
import { useAnalytics } from '../../../../hooks/use-analytics';
import { RideType } from '../../../../views/ford-rides-view/ford-rides-view';
import { PrimaryButton } from '../../../common';

type exportType = 'pdf' | 'excel';
interface Props {
    rideType?: RideType[];
}
function RidesExport(props: Props) {
    const fordRidesExportData = useFordExportRidesContent();
    const [exportType, setExportType] = useState<exportType>('pdf');
    const { fordRidesExport } = useFordRidesContext();
    const [fireEvents] = useAnalytics();

    useEffect(() => {
        fireEvents(['ford-rides-export-cta'], undefined, undefined, false);
    }, []);
    if (!Object.keys(fordRidesExportData).length) {
        return <ActivityIndicator />;
    }
    return (
        <div className="export-rides-data__wrapper">
            <div className="export-card">
                <h3 className="export-title">
                    {fordRidesExportData.exportHeadingText}
                </h3>
                <p className="export-format">
                    {fordRidesExportData.exportFormatText}
                </p>
                <select
                    className="field-text-label"
                    value={exportType}
                    onChange={e => setExportType(e.target.value as exportType)}
                >
                    <option value="pdf">
                        {fordRidesExportData.exportPdfText}
                    </option>
                    <option value="excel">
                        {fordRidesExportData.exportCsvText}
                    </option>
                </select>
                <div className="note-text">
                    {fordRidesExportData.exportInfoText}
                </div>
                <div className="export-rides-cta">
                    <PrimaryButton
                        className="export-button-text"
                        color="dark"
                        fill="outline"
                        chevron={true}
                        ariaLabel={`Export ${exportType}`}
                        onClick={() => {
                            if (props.rideType) {
                                fordRidesExport(exportType, props.rideType);
                            }
                        }}
                    >
                        {fordRidesExportData.exportCtaText}
                    </PrimaryButton>
                </div>
            </div>
        </div>
    );
}

export default RidesExport;
